var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Name"}},[_c('input-text',{staticClass:"w-full",attrs:{"name":"name","value":_vm.broker.name,"placeholder":"Name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }